<template>
  <div class="Footer">
    <button class="uk-button uk-button-primary inquiryNow" v-if="showInquiryNow" @click="navigateToInquiry">
      {{'inquire_now'|translate}}
    </button>
    <hr class="uk-divider-icon">
    <div class="uk-container ContentCon">
      <div uk-grid>
        <div class="uk-width-1-3@l uk-width-1-3@m  uk-width-1-1@s">
          <img class="Logo" :src="`${ASSETS_BASE_URL}/images/logo.png`"/>
        </div>
        <div class="uk-width-2-3@l uk-width-2-3@m  uk-width-1-1@s">
          <div uk-grid>
            <div class="uk-width-1-4@l uk-width-1-4@m uk-width-1-1@s">
              <ul class="uk-list RouteLinks">
                <li>
                  <router-link to="/home">
                    {{'home'|translate}}
                  </router-link>
                </li>
                <li>
                  <router-link to="/casamia-nilaveli">
                    CASAMIA Nilaveli
                  </router-link>
                </li>
                <li>
                  <router-link to="/casamia-colombo">
                    CASAMIA Colombo
                  </router-link>
                </li>
                <li>
                  <router-link to="/turtle-nest">
                    Turtle Nest Rekawa
                  </router-link>
                </li>
                <li>
                  <router-link to="/excursions">
                    {{'excursions'|translate}}
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="uk-width-1-4@l uk-width-1-4@m uk-width-1-1@s">
              <ul class="uk-list RouteLinks">
                <li>
                  <router-link to="/gallery">
                    {{'gallery'|translate}}
                  </router-link>
                </li>
                <li>
                  <router-link to="/about-us">
                    {{'about_us'|translate}}
                  </router-link>
                </li>
                <li>
                  <router-link to="/inquiry">
                    {{'inquiry'|translate}}
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="uk-width-1-4@l uk-width-1-3@m uk-width-1-1@s">
              <div uk-grid>
                <div class="uk-width-1-1@m uk-width-1-1@s">
                  <a href="https://www.facebook.com/HomewindLeisures" target="_blank"
                     class="uk-icon-button uk-margin-small-right social-media-icon" uk-icon="facebook"></a>
                  <a href="https://www.instagram.com/homewindleisures" target="_blank"
                     class="uk-icon-button  uk-margin-small-right social-media-icon" uk-icon="instagram"></a>
                  <a href="https://www.youtube.com/channel/UC7nWPW6gvIWLVh7y8dB9B1Q" target="_blank"
                     class="uk-icon-button social-media-icon" uk-icon="youtube"></a>
                </div>
                <div class="contact-details">
                  <ul class="uk-list">
                    <li class="Heading">{{'contact'|translate}}</li>
                    <li class="Text">Homewind Leisures</li>
                    <li class="Text">No. 21, Siebel Avenue</li>
                    <li class="Text">Colombo 5, Sri Lanka</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="uk-width-1-1@l uk-width-1-1@m  uk-width-1-1@s">
          <p class="CopyRights">All Copyrights Reserved © Homewind Leisures</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
  data: function () {
    return {
      showInquiryNow: false
    }
  },
  watch: {
    $route (to, from) {
      this.showInquiryNow = to.name !== 'Inquiry'
    }
  },
  mounted: function () {
    this.showInquiryNow = this.$router.currentRoute.name !== 'Inquiry'
  },
  methods: {
    navigateToInquiry: function () {
      this.$router.push('/inquiry')
    }
  }
}
</script>

<style scoped>
  .Footer {
    padding-bottom: 40px;
    /*background: #ECE9E6; !* fallback for old browsers *!*/
    /*background: -webkit-linear-gradient(to top, #ECE9E6, #FFFFFF); !* Chrome 10-25, Safari 5.1-6 *!*/
    /*background: linear-gradient(to top, #ECE9E6, #FFFFFF); !* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ *!*/
  }

  .ContentCon {
    padding-top: 40px;
  }

  .Logo {
    width: 250px;
  }

  .RouteLinks > li > a {
    text-decoration: none;
    color: #a9a9a9;
  }

  .RouteLinks > li > a:hover {
    color: #3e3f3e;
  }

  .Heading {
    color: #848484;
    font-weight: 500;
  }

  .Text {
    color: #a9a9a9;
  }

  .CopyRights {
    color: #a9a9a9;
    font-size: 14px;
    text-align: center;
  }

  .inquiryNow {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    border-radius: 50px;
    background: #cf0015;
  }

  .inquiryNow:hover, .inquiryNow:focus {
    background: #a50014;
  }

  .social-media-icon {
    background: #ca420e;
    color: #FFF;
  }

  .social-media-icon:hover {
    background: #ab2f00 !important;
  }

  .contact-details {
    margin-top: 20px !important;
  }
</style>
